/*
 * @Author: cc
 * @Date: 2020-09-01 10:11:22
 * @LastEditTime: 2021-04-20 14:21:26
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\resourceCenter\materialResource\personalMaterial\personalMaterial.js
 * @Description: 
 */
/**
 * 个人素材库控制器，需要继承素材库主控制器
 */
'use strict';

angular.module('resourceCenterMaterialModule').controller('personalMaterialCtrl', [
    '$scope',
    '$controller',
    'mrApiService',
    '$q',
    '$stateParams',
    '$element',
    '$compile',
    function ($scope, $controller, mrApiService, $q, $stateParams, $element, $compile) {
        // eslint-disable-next-line no-unused-vars
        initScope();
        initStatus();
        initData();

        /**
         * [initScope 初始化作用域，继承素材库主控制器]
         *
         * @return  {[type]}          [return description]
         */
        function initScope() {
            let vm = this || window;
            let parentCtr = $controller('resCenterMRRelCtrl', { $scope: $scope, mrApiService: mrApiService, $q: $q, });
            vm = angular.extend(vm, parentCtr);
        }

        /**
         * [initScope 初始化状态]
         *
         * @return  {[type]}          [return description]
         */
        function initStatus() {
            $scope.title = '个人素材';
            $scope.basicalStatus.commonParams.mrType = 'personal';
            $scope.basicalStatus.commonParams.mainResourceType = $stateParams.resourcetype;
            $scope.basicalStatus.buttonCheck.name = 'personalmaterial';
            $scope.basicalStatus.buttonCheck.ModalName = '个人素材库';
            $scope.basicalStatus.ispersonalmaterial = true;
        }

        /**
         * [initScope 初始化数据]
         *
         * @return  {[type]}          [return description]
         */
        function initData() {
            $scope.requestData();
            initMessageChange();
        }


        // TODO 提取为公共方法
        /**
         * [initMessageChange 初始化信息编辑组件]
         *
         * @return  {[type]}          [return description]
         */
        function initMessageChange() {
            var message = '<message-change></message-change>';
            message = $compile(message)($scope);
            $element.find('messageChange').append(message);
        }

    },
]);
